module.exports = __webpack_public_path__ + "static/media/model.abf738a3.svg";